import { render } from "./viewAlertDetails.vue?vue&type=template&id=7dc8a3aa&scoped=true"
import script from "./viewAlertDetails.js?vue&type=script&lang=js"
export * from "./viewAlertDetails.js?vue&type=script&lang=js"

import "./viewAlertDetails.vue?vue&type=style&index=0&id=7dc8a3aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc8a3aa"]])

export default __exports__